import { TFunction } from '@lyearn/i18n';
import { CheckMark } from '@lyearn/icons';
import { SectionLayout } from '@/components/Form';
import { ListWithTempId } from '@/hooks/useList/useListWithTempId';
import { ContentCardTypeEnum } from '@/modules/content/config/cards';
import {
  PageComponentTypeEnum,
  PageConfigType,
  WidgetPropsInput,
  WidgetTypeEnum,
} from '@/types/schema';

import { HomepageEditorSidebarView } from './hooks/useHomeEditor/enums';
import { PageComponentInputWithLayout } from './hooks/useHomeEditor/types';

export enum HomeEditorQueryKey {
  BannerWidget = 'banner',
  PageComponent = 'page-component',
  Navigation = 'navigation',
}

export interface SidebarViewType {
  type: HomepageEditorSidebarView;
  index?: number;
  appendQuery?: boolean;
}

export interface GetFieldsProps {
  t: TFunction;
  nameAttributes?: { placeholder?: string; props?: any };
  type: PageComponentTypeEnum;
  pageConfigs?: PageConfigType;
  widgetType?: WidgetTypeEnum;
}

export interface GetSectionLayoutProps {
  t: TFunction;
  widgetItem: ListWithTempId<PageComponentInputWithLayout>;
}

export interface WidgetsConfigType {
  props?: { size?: ContentCardTypeEnum; type?: ContentCardTypeEnum };
  type: PageComponentTypeEnum;
  widgetProps?: WidgetPropsInput;
  Icon: typeof CheckMark;
  titleKey: string;
  descriptionKey: string;
  hintKey?: string;
  canBeMultiple: boolean;
  formConfig?: {
    getFields?: (props: GetFieldsProps) => any;
    getSectionLayout?: (props: GetSectionLayoutProps) => SectionLayout;
    validateForm?: (values: ListWithTempId<PageComponentInputWithLayout>) => any;
  };
  descriptionPlaceholderKey?: string;
  Component?: (props: any) => any; // optional to be removed later after multi banner support remains
}
